// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.confirmation-list {\n  margin: 20px 0 0 32px;\n}\n.error-text-item {\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
